export default "__VITE_ASSET__89ce139c__"